 import React from "react";

export default function Footer() {
    return (
        <div className="Footer">
 <footer>
          <p>
            <a
              href="https://github.com/Sbulford35/sarahb-react-weatherapp"
              target="_blank"
              rel="noreferrer"
            >
              Open source code
            </a>{" "}
            by Sarah Bulford <br />
            Hosted with <a href="https://www.netlify.com">Netlify</a>
          </p>
        </footer>
        </div>
    );
}